import React, { Component } from "react";
import Header from "../../partials/header";
import Footer from "../../partials/less-content-footer";
import { connect } from "react-redux";
import { 
    showMessage
} from '../../actions/popupMessageActions';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import * as moment from 'moment';
import { CSVLink } from "react-csv";

import {
  Modal,
  Tabs,
  Tab,
  Table,
  Col,
  Container,
  Row,
  Form,
  Spinner,
  Button
} from "react-bootstrap";
import axios from "axios";

class AdminReports extends Component {
  constructor() {
    super();
    this.state = {
      reports: [],
      indivdualList: [],
      showModalIndividual: false,
      receiptNum: "",
      startDate: new Date(),
      endDate: new Date(),
      receipt: "",
      credit_card: "",
      username: "",
      mode: "",
      accountId: "",
      payeezy: "",
      totalOnline: "",
      totalPhonedIn: "",
      sumOnline: "",
      sumPhonedin: "",
      buttonIsDisabled: false,
      isLoading: true,
      fileName: 'GWA-Admin-Control-Reports-'+moment().format("DD-MM-YYYY")+".csv",
      indivdualTransLog: [],
      // server-side pagination
      page: 1,
      sizePerPage: 10,
      totalSize: 0,
      searchParams: null, // filters of the last search; null = today's default list
      exportData: [],
      isExporting: false,
    };
    this.requestSeq = 0;
  }
  componentWillMount() {
    this.getReports();
  }

  // Loads one page from the API: today's default list, or the last search when searchParams is set.
  // Without page/sizePerPage the API returns every row (used by CSV export).
  requestReports = (searchParams, page, sizePerPage) => {
    const paging = page ? { page: page, per_page: sizePerPage } : {};
    const config = { headers: { "Content-Type": "application/json" } };
    if (searchParams === null) {
      return axios.get("/api/v1/transactions", { ...config, params: paging });
    }
    return axios.post("/api/v1/search-transaction", { ...searchParams, ...paging }, config);
  };

  loadPage = (searchParams, page, sizePerPage) => {
    // ignore responses from older requests (e.g. fast clicks through pages)
    const seq = ++this.requestSeq;
    return this.requestReports(searchParams, page, sizePerPage)
      .then(response => {
        if (seq !== this.requestSeq) return;
        const result = response.data.result;
        this.setState({
          reports: result.list,
          totalSize: result.total,
          page: page,
          sizePerPage: sizePerPage,
          searchParams: searchParams,
          sumOnline: result.sumOnline,
          sumPhonedin: result.sumPhonedin,
          totalOnline: result.totalOnline,
          totalPhonedIn: result.totalPhonedIn,
          buttonIsDisabled: false,
          isLoading: false
        });
      })
      .catch(error => {
        if (seq !== this.requestSeq) return;
        this.setState({ buttonIsDisabled: false, isLoading: false });
        this.props.showMessage('danger', "Server Error!");
      });
  };

  getReports = () => {
    return this.loadPage(null, 1, this.state.sizePerPage);
  };

  searchReports = e => {
    this.setState({reports:[],buttonIsDisabled:true,isLoading:true});
    e.preventDefault();
    let startDateSave = this.state.startDate != null ? moment(this.state.startDate).format('MM/DD/YYYY'):null;
    let endDateSave = this.state.endDate != null ? moment(this.state.endDate).format('MM/DD/YYYY'):null;
    const searchParams = {
      pay_date_start: startDateSave,
      pay_date_end: endDateSave,
      receipt: this.state.receipt,
      credit_card: this.state.credit_card,
      username: this.state.username,
      mode: this.state.mode,
      accountId: this.state.accountId,
      // payeezy: this.state.payeezy
      auth_no: this.state.payeezy
    };
    return this.loadPage(searchParams, 1, this.state.sizePerPage);
  };

  handleTableChange = (type, { page, sizePerPage }) => {
    if (type === 'pagination') {
      this.loadPage(this.state.searchParams, page, sizePerPage);
    }
  };

  // CSV export covers every row of the current list/search, not just the visible page.
  exportCsv = e => {
    e.preventDefault();
    this.setState({ isExporting: true });
    this.requestReports(this.state.searchParams)
      .then(response => {
        this.setState({ exportData: response.data.result.list, isExporting: false }, () => {
          this.csvLink.link.click();
        });
      })
      .catch(error => {
        this.setState({ isExporting: false });
        this.props.showMessage('danger', "Server Error!");
      });
  };

  inputChange = e => {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value
    });
  };

  renderList() {
    const columns = 
    [
      {
        dataField: 'username',
        text: 'User ID',
        formatter: (cellContent, row) => (
          <a id={row.id} receipt={row.receipt_number} onClick={this.getTranslog.bind(this)}>{row.username}</a>
        )
      }, {
        dataField: 'accountId',
        text: 'Account #',
      }, {
        dataField: 'auth_no',
        text: 'Auth #',
      }, {
        dataField: 'payment_date',
        text: 'Payment Date',
      }, {
        dataField: 'receipt_number',
        text: 'Receipt #',
      },{
        dataField: 'count',
        text: '# of Payments',
      },{
        dataField: 'transaction_tag',
        text: 'Trans. Tag',
      },
      // {
      //   dataField: 'pay_eezy_seq_num',
      //   text: 'Payeezy Seq. #',
      //   sort: true,
      // },
      {
        dataField: 'amount',
        text: 'Amount',
      }, {
        dataField: 'id',
        text: 'Details',
        formatter: (cellContent, row) => (
          <a id={row.id} receipt={row.receipt_number} onClick={this.getIndividual.bind(this)}>view</a>
        )
      }, {
        dataField: 'process_message',
        text: 'Process Msg'
      }, {
        dataField: 'bank_response',
        text: 'Bank Response'
      }, {
        dataField: 'mode',
        text: 'Mode'
      },{ 
        dataField: 'ccb_status',
        text: 'In CCB',
      }
    ];

    const options = {
      paginationSize: 4,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: 'First',
      prePageText: 'Back',
      nextPageText: 'Next',
      lastPageText: 'Last',
      nextPageTitle: 'First page',
      prePageTitle: 'Pre page',
      firstPageTitle: 'Next page',
      lastPageTitle: 'Last page',
      showTotal: true,
      page: this.state.page,
      sizePerPage: this.state.sizePerPage,
      totalSize: this.state.totalSize,
      // paginationTotalRenderer: customTotal,
      sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '30', value: 30
      }, {
        text: '50', value:50
      }]
    };


    const headers = [
      {
        label: 'UserId',
        key: 'username'
      },
      {
        label: 'Account #',
        key: 'accountId'
      },
      {
        label: 'Auth #',
        key: 'auth_no'
      },
      {
        label: 'Payment Date',
        key: 'payment_date'
      },
      {
        label: 'Receipt #',
        key: 'receipt_number'
      },
      {
        label: '# of Payments',
        key: 'count'
      },
      {
        label: 'Trans. Tag',
        key: 'transaction_tag'
      },
      // {
      //   label: 'Payeezy Seq. #',
      //   key: 'pay_eezy_seq_num'
      // },
      {
        label: 'Amount',
        key: 'amount'
      },
      {
        label: 'Process Msg',
        key: 'process_message'
      },
      {
        label: 'Bank Response',
        key: 'bank_response'
      },
      {
        label: 'Mode',
        key: 'mode'
      },
      {
        label: 'In CCB',
        key: 'ccb_status'
      },
    ]

   return (
      <div id="report-list-container">
        <div class="csv-container">
          <a href="#" onClick={this.exportCsv} className="btn-export-csv">
            { this.state.isExporting ? "Exporting..." : "Export CSV" }
          </a>
          <CSVLink 
            data={ this.state.exportData }
            headers={headers}
            filename={this.state.fileName} 
            ref={ r => (this.csvLink = r) }
            style={{ display: 'none' }}
            target="_blank" />
        </div>
        <BootstrapTable 
        bootstrap4 = {true}
        keyField='id' 
        remote={ { pagination: true } }
        data={ this.state.reports } 
        columns={ columns } 
        pagination={ paginationFactory(options) }
        onTableChange={ this.handleTableChange }
        noDataIndication="No Web Payments Made"  
        hover
        condensed
        wrapperClasses="table-responsive"
        />
        
      </div>
    );
  }

  getIndividual = (e) => {
    let id = e.currentTarget.getAttribute("id");
    let receiptNum = e.currentTarget.getAttribute("receipt");
    e.preventDefault();
    return axios
    .get('/api/v1/get-individual/'+id, 
    {
        headers: {'Content-Type':'application/json'}
    })
    .then(response => {
      this.setState({
        receiptNum: receiptNum,
        indivdualList: response.data.result.data
      }, () => {
        console.clear();
        
          if(this.state.indivdualList != null) {
            this.setState({
              showModalIndividual: true
            })
          }
      });
      
    });
}

getTranslog = (e) => {
  let id = e.currentTarget.getAttribute("id");
  e.preventDefault();
  return axios
  .post('/api/v1/search-transaction-logs', 
  {
    overallId: id,
    pay_date_start: '',
    pay_date_end: ''
  },
  {
      headers: {'Content-Type':'application/json'}
  })
  .then(response => {
    this.setState({
      indivdualTransLog: response.data
    }, () => {
      // console.clear();
          this.setState({
            showModalTranslog: true
          })
    });
    
  });
}
  handleCloseModalIndividual = () => {
    this.setState({ showModalIndividual: false });
  };
  handleCloseModalIndividualTransLogs= () => {
    this.setState({ showModalTranslog: false });
  };
  handleChangeStart = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEnd = (date) => {  
    this.setState({
      endDate: date
    });
  };

  render() {

    const columnsTransLog = 
    [
      {
        text: 'Insert overall transaction result',
        formatter: (cellContent, row) => (
          <pre>{JSON.stringify(row.save_over_all_transaction, undefined, 2)}</pre>
        )
      },{
        text: 'Insert individual transaction result',
        formatter: (cellContent, row) => (
          <pre>{JSON.stringify(row.save_individual_transation, undefined, 2)}</pre>
        )
      }, {
        text: 'Payeezy result',
        formatter: (cellContent, row) => (
          <pre style={{width: '310px'}}>{JSON.stringify(row.payeezy_response, undefined, 2)}</pre>
        )
      }, {
        text: 'CCB make payment result',
        formatter: (cellContent, row) => (
          <pre>{JSON.stringify(row.save_ccb_response, undefined, 2)}</pre>
        )
      }, {
        text: 'Email result',
        formatter: (cellContent, row) => (
          <pre>{JSON.stringify(row.email_response, undefined, 2)}</pre>
        )
      }, {
        text: 'Update overall transaction result',
        formatter: (cellContent, row) => (
          <pre>{JSON.stringify(row.update_over_all_transaction, undefined, 2)}</pre>
        )
      }, {
        text: 'Update individual transaction result',
        formatter: (cellContent, row) => (
          <pre>{JSON.stringify(row.update_individual_transaction, undefined, 2)}</pre>
        )
      }
    ];

    const columns = 
    [
      {
        dataField: 'account_number',
        text: 'Account No.',
      },{
        dataField: 'receipt_num',
        text: 'Receipt No.',
      }, {
        dataField: 'amount',
        text: 'Amount'
      }, {
        dataField: 'status',
        text: 'Status'
      }, {
        dataField: 'ccb_status',
        text: 'In CCB'
      }, {
        dataField: 'payment_date',
        text: 'GWA Interface Data'
      }
    ];

    return (
      <React.Fragment>
        <Modal
          show={this.state.showModalTranslog}
          onHide={this.handleCloseModalIndividualTransLogs}
          // aria-labelledby="contained-modal-title-vcenter"
          id="modal-for-individualtranslog"
          backdrop="static"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <BootstrapTable 
              bootstrap4 = {true}
              keyField='id' 
              data={ this.state.indivdualTransLog } 
              columns={ columnsTransLog } 
              noDataIndication="No transaction log found"  
              hover
              condensed
              wrapperClasses="table-responsive"
            />
          <div className="btn-submit-change-ok">
              <button
                type="submit"
                onClick={this.handleCloseModalIndividualTransLogs}
                className="btn btn-change-ok font-bold btn-primary"
              >
                Close
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showModalIndividual}
          onHide={this.handleCloseModalIndividual}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          id="modal-for-individual"
          backdrop="static"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <p>Payment Details for Receipt Number: {this.state.receiptNum}</p>
            <BootstrapTable 
              bootstrap4 = {true}
              keyField='id' 
              data={ this.state.indivdualList } 
              columns={ columns } 
              noDataIndication="No Web Payments Made"  
              hover
              condensed
              wrapperClasses="table-responsive"
            />
          <div className="btn-submit-change-ok">
              <button
                type="submit"
                onClick={this.handleCloseModalIndividual}
                className="btn btn-change-ok font-bold btn-primary"
              >
                Close
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Container fluid={true}>
          <Row>
            <Col>
              <div id="admin-reports-container">
                <h5>All Payments/Transaction Inquiry</h5>
                <h6>(Successful and Unsuccessful Transactions)</h6>
                <p>Search for a Payment Transactions</p>
                <div className="search-container">
                  <div className="search-container-left">
                    <div className="input-cont">
                      <label>Pay Date Start: </label><div className="input-right"><DatePicker dateFormat="MM/dd/yyyy" selected={this.state.startDate} onChange={this.handleChangeStart} /></div>
                    </div>
                    <div className="input-cont">
                      <label>Receipt No.: </label><div className="input-right"><input type="text" autocomplete="off" name="receipt" onChange={this.inputChange.bind(this)} /></div>
                    </div>
                    <div className="input-cont">
                      <label>User ID:</label><div className="input-right"><input type="text" autocomplete="off" name="username" onChange={this.inputChange.bind(this)} /></div>
                    </div>
                    <div className="input-cont">
                      <label>Account No.:</label><div className="input-right"><input type="text" autocomplete="off" name="accountId" onChange={this.inputChange.bind(this)} /></div>
                    </div>
                  </div>
                  <div className="search-container-right">
                    <div className="input-cont">
                      <label>Pay Date End: </label><div className="input-right"><DatePicker dateFormat="MM/dd/yyyy" selected={this.state.endDate} onChange={this.handleChangeEnd} /></div>
                    </div>
                    <div className="input-cont">
                      <label>Credit Card Transaction Tag: </label><div className="input-right"><input type="text" autocomplete="off" name="credit_card" onChange={this.inputChange.bind(this)} /></div>
                    </div>
                    <div className="input-cont">
                      <label>Mode:</label>
                        <div className="input-right">
                          <select name="mode" onChange={this.inputChange.bind(this)} >
                            <option value=""></option>
                            <option value="Online">Online</option>
                            <option value="Phoned-In">Phoned-In</option>
                          </select>
                        </div>
                    </div>
                    <div className="input-cont">
                      {/* <label>Payeezy Sequence No.:</label><div className="input-right"><input type="text" name="payeezy" autocomplete="off" /></div> */}
                      <label>Authorization #:</label><div className="input-right"><input type="text" name="payeezy" autocomplete="off" onChange={this.inputChange.bind(this)}/></div>
                    </div>
                  </div>
                  <div>
                    {
                      this.state.buttonIsDisabled ? 
                      <button
                          type="submit"
                          disabled
                          className="btn btn-change-ok font-bold "
                        >
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Loading...
                      </button>
                      :
                      <button
                          type="submit"
                          onClick={this.searchReports.bind(this)}
                          className="btn btn-change-ok font-bold btn-primary"
                        >
                          Search
                      </button>
                    }
 
                  </div>
                </div>

                <div className="total-cont">
                  <div className="total-left">
                    <p><label>Total No of Online Payments</label><span>{this.state.totalOnline}</span></p>
                    <p><label>Total No of Phoned-In Payments</label><span>{this.state.totalPhonedIn}</span></p>
                  </div>
                  <div className="total-right">
                    <p><label>Total Amount of Online Payments</label><span>{this.state.sumOnline}</span></p>
                    <p><label>Total Amount of Phoned-In Payments</label><span>{this.state.sumPhonedin}</span></p>
                  </div>
                </div>
                  { this.state.isLoading ? 
                    <div style={{marginTop: '50px'}}>
                        <center>
                        <Spinner
                            
                            as="span"
                            animation="border"
                            size="md"
                            role="status"
                            aria-hidden="true"
                        />
                        </center>
                    </div> :
                    this.renderList()
                  }
                
                      
              </div>
          </Col>
        </Row>
      </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dashboard: state.dashboard
});

export default connect(mapStateToProps, 
{ 
  showMessage 
})(AdminReports);
